import React, { useRef, useEffect } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { AssetContainer, useAsset } from '~/techstyle-shared/react-assets';
import {
  Video,
  useListViewed as usePromoListViewed,
} from '~/techstyle-shared/react-components';

import { parseVideoIdInput } from '../../utils/assetHelper';

const Wrapper = styled.div`
  width: 100%;
  height: auto;
`;

const VideoWithNoPointerEvents = styled(Video)`
  pointer-events: none;
`;

export default function TrackedAssetContainer({
  name = '',
  asset,
  url = '',
  children,
  ...props
}) {
  const trackedAssetRef = useRef(null);
  const assetData = useAsset(name);
  if (!asset && assetData) {
    const { assets = [] } = assetData.data;
    asset = assets[0];
  }

  const { videoId, videoTargetUrl } = parseVideoIdInput({ asset });
  const isVideoAsset = videoId;

  const promoListViewedHelpers = usePromoListViewed();
  const hasHelpers = Boolean(promoListViewedHelpers);
  const isVideoContainer = Boolean(url) || isVideoAsset;

  useEffect(() => {
    if (!hasHelpers) {
      return () => {};
    }

    const node = trackedAssetRef.current;
    const { observe, unobserve } = promoListViewedHelpers;
    if (node && hasHelpers) {
      observe(node, { ...asset, isVideoAsset });
    }

    return () => unobserve(node);
  }, [hasHelpers, promoListViewedHelpers, asset, isVideoAsset]);

  if (children) {
    return <Wrapper ref={trackedAssetRef}>{children}</Wrapper>;
  }

  if (isVideoContainer) {
    return (
      <Wrapper ref={trackedAssetRef}>
        {videoTargetUrl ? (
          <a href={videoTargetUrl}>
            <VideoWithNoPointerEvents url={url} {...props} />
          </a>
        ) : (
          <Video url={url} {...props} />
        )}
      </Wrapper>
    );
  }

  return (
    <Wrapper ref={trackedAssetRef}>
      <AssetContainer name={name} {...props} />
    </Wrapper>
  );
}

TrackedAssetContainer.propTypes = {
  asset: PropTypes.object,
  children: PropTypes.node,
  isVideoAsset: PropTypes.bool,
  name: PropTypes.string,
  url: PropTypes.string,
};
